import React from 'react';
import PropTypes from 'prop-types';

import BrowserDetection from 'react-browser-detection';
import { Segment, Divider } from 'semantic-ui-react';
import BrowserHandler from '../../utils/browser-handler';
import Header from '../../components/header';
import PoweredByDyzio from '../../components/powered-by-dyzio';

const NewInfluencer = ({ children }) => (
  <div>
    <Header />
    <div className="page">
      <div className="page-content">
        <Segment>
          { children }
          <Divider hidden />
        </Segment>
      </div>

      <Divider hidden />
      <div className="align-center">
        <div className="browser-detect">
          <PoweredByDyzio />
          <BrowserDetection>
            {BrowserHandler.handle}
          </BrowserDetection>
        </div>
      </div>
      <Divider hidden />
    </div>
  </div>
);

NewInfluencer.propTypes = {
  children: PropTypes.object.isRequired,
};

export default NewInfluencer;



/** WEBPACK FOOTER **
 ** ./src/containers/new-influencer/index.js
 **/